module.exports = __webpack_public_path__ + "fonts/Inter-900-greek81.eb1153e.woff2";